import firebase from "firebase";
import { db, functions, storage } from "@/firebase";
import { idToTexto, redondeo } from "@/utils/utils.js";
import { restSinNegocio2 } from "@/utils/restaurantes.utils.js";
import XLSX from "xlsx";
import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
	getDatosFacturacionNegocioGest({ rootState, commit }) {
		const negocio = rootState.app.negocioGest;
		return db
			.collection("negocios")
			.doc(negocio)
			.collection("secreto")
			.doc("facturacion")
			.get()
			.then((r) => {
				if (r.exists) {
					let d = r.data();
					commit("setDatosFacturacionNegocioGest", d);
				}
			});
	},
	getDatosFacturacionDirectorioGest({ rootState, commit }) {
		const directorio = rootState.app.directorioGest;
		return db
			.collection("directorios")
			.doc(directorio)
			.collection("secreto")
			.doc("facturacion")
			.get()
			.then((r) => {
				if (r.exists) {
					let d = r.data();
					commit("setDatosFacturacionNegocioGest", d);
				}
			});
	},
	getNumeroFacturaSiguiente({ dispatch }) {
		let numero;
		var f = functions.httpsCallable("httpFacturasGetNumeroHolded");
		return f().then((r) => {
			console.log(r);
			let sig = r.data + 1;
			return dispatch("setNumeroFacturaSiguiente", sig).then(() => sig);
			return db
				.collection("facturas")
				.doc("datos")
				.get()
				.then((r) => {
					if (r.exists) {
						const d = r.data();
						numero = d.numero;
					} else {
						numero = 1;
					}
					return numero;
				});
		});
	},
	setNumeroFacturaSiguiente({}, numero) {
		return db.collection("facturas").doc("datos").set(
			{
				numero: numero,
			},
			{ merge: true }
		);
	},
	async getPedidosFacturacion(
		{ state, commit, rootState },
		{ negocio, directorio, restaurantes, tipo }
	) {
		var paginar = true;
		var limit = 30;
		var start = null;
		let r1 = moment(state.rangoFacturando[0])
			.hour(rootState.estadisticas.horaInicio)
			.toDate();
		let r2 = moment(state.rangoFacturando[1])
			.hour(rootState.estadisticas.horaInicio)
			.add(1, "days")
			.toDate();
		//tomar para negocios
		const func = async () => {
			var consulta;
			if (start) {
				consulta = db
					.collection("pedidos")
					.where("estado", "==", "finalizado")
					.where("negocio", "==", negocio)
					.where("fechaServidor", ">", r1)
					.where("fechaServidor", "<", r2)
					.orderBy("fechaServidor", "desc")
					.startAfter(start)
					.limit(limit);
			} else {
				consulta = db
					.collection("pedidos")
					.where("estado", "==", "finalizado")
					.where("negocio", "==", negocio)
					.where("fechaServidor", ">", r1)
					.where("fechaServidor", "<", r2)
					.orderBy("fechaServidor", "desc")
					.limit(limit);
			}
			return consulta.get().then((r) => {
				if (r.size > 0) {
					const pedidos = r.docs.map((p) => {
						start = p;
						const data = p.data();
						delete data.copyRest;
						delete data.copyNegocio;
						return {
							...data,
							id: p.id,
						};
					});
					return pedidos;
				}
			});
		};

		//tomar para directorios
		const funcDirectorio = async () => {
			var consulta;

			console.log(r1);
			console.log(r2);
			console.log(start);
			if (start) {
				consulta = db
					.collection("pedidos")
					.where("estado", "==", "finalizado")
					.where("directorio", "==", negocio)
					.where("fechaServidor", ">", r1)
					.where("fechaServidor", "<", r2)
					.orderBy("fechaServidor", "desc")
					.startAfter(start)
					.limit(limit);
			} else {
				consulta = db
					.collection("pedidos")
					.where("estado", "==", "finalizado")
					.where("directorio", "==", negocio)
					.where("fechaServidor", ">", r1)
					.where("fechaServidor", "<", r2)
					.orderBy("fechaServidor", "desc")
					.limit(limit);
			}
			return consulta.get().then((r) => {
				if (r.size > 0) {
					console.log(r.size);
					const pedidos = r.docs.map((p) => {
						start = p;
						const data = p.data();
						delete data.copyRest;
						delete data.copyNegocio;
						delete data.copyDirectorio;
						return {
							...data,
							id: p.id,
						};
					});
					return pedidos;
				}
			});
		};
		//tomar para facturación rest
		const funcRest = async (rest) => {
			var consulta;
			let restConsultar = restSinNegocio2(rest, negocio);
			if (start) {
				consulta = db
					.collection("pedidos")
					.where("estado", "==", "finalizado")
					.where("negocio", "==", negocio)
					.where("restaurante", "==", restConsultar)
					.where("fechaServidor", ">", r1)
					.where("fechaServidor", "<", r2)
					.orderBy("fechaServidor", "desc")
					.startAfter(start)
					.limit(limit);
			} else {
				consulta = db
					.collection("pedidos")
					.where("estado", "==", "finalizado")
					.where("negocio", "==", negocio)
					.where("restaurante", "==", restConsultar)
					.where("fechaServidor", ">", r1)
					.where("fechaServidor", "<", r2)
					.orderBy("fechaServidor", "desc")
					.limit(limit);
			}
			return consulta.get().then((r) => {
				if (r.size > 0) {
					const pedidos = r.docs.map((p) => {
						start = p;
						const data = p.data();
						delete data.copyRest;
						delete data.copyNegocio;
						return {
							...data,
							id: p.id,
						};
					});
					return pedidos;
				}
			});
		};
		commit("setPedidosRango", []);
		commit("setOverlayPedidos", true);
		if (
			restaurantes &&
			Array.isArray(restaurantes) &&
			restaurantes.length > 0
		) {
			for (const rest of restaurantes) {
				paginar = true;
				limit = 30;
				start = null;
				while (paginar) {
					let pedidosAux = await funcRest(rest.id);
					if (!pedidosAux) {
						paginar = false;
						//commit('setOverlayPedidos', false);
					} else {
						commit("pushPedidosRango", pedidosAux);
						if (pedidosAux.length < limit) {
							paginar = false;
							//commit('setOverlayPedidos', false);
						}
					}
				}
			}
		} else if (tipo == "negocio") {
			while (paginar) {
				let pedidosAux = await func();
				if (!pedidosAux) {
					paginar = false;
					commit("setOverlayPedidos", false);
				} else {
					commit("pushPedidosRango", pedidosAux);
					if (pedidosAux.length < limit) {
						paginar = false;
						commit("setOverlayPedidos", false);
					}
				}
			}
		} else if (tipo == "directorio") {
			negocio = negocio.replace("directorio_", "");
			while (paginar) {
				console.log("paginar");
				let pedidosAux = await funcDirectorio();
				console.log(pedidosAux);
				if (!pedidosAux) {
					paginar = false;
					commit("setOverlayPedidos", false);
				} else {
					commit(
						"pushPedidosRango",
						pedidosAux.filter((p) => !p.multipleEsHijo)
					);
					if (pedidosAux.length < limit) {
						paginar = false;
						commit("setOverlayPedidos", false);
					}
				}
			}
		}
	},
	getPedidosFactura({}, id_factura) {
		return db
			.collection("facturas")
			.doc(id_factura)
			.collection("datos")
			.doc("pedidos")
			.get()
			.then((r) => {
				if (r.exists) {
					return r.data().listado;
				} else {
					return Promise.reject("factura/not-found");
				}
			});
	},
	generarFactura({ rootState, state, dispatch }, factura) {
		console.log(factura);
		var numero;
		var id_factura;
		var pedidosAux;
		factura.negocio =
			factura.modo == "directorio"
				? factura.negocio.replace("directorio_", "")
				: factura.negocio;
		var id =
			factura.restaurante && factura.restaurante.length > 0
				? factura.restaurante[0]
				: factura.negocio;

		//var negRest = (factura.restaurante) ?
		return db
			.collection("facturas")
			.doc("datos")
			.get()
			.then((r) => {
				if (r.exists) {
					const d = r.data();
					numero = d.numero;
				} else {
					numero = 1;
				}
				// return db
				// 	.collection("facturas")
				// 	.doc("datos")
				// 	.set({ numero: numero + 1 }, { merge: true });
			})
			.then(() => {
				id_factura = numero.toString().padStart(10, "0");
				pedidosAux = factura.pedidos;
				console.log(pedidosAux);
				delete factura.pedidos;

				return Promise.all([
					db
						.collection("facturas")
						.doc(id_factura)
						.collection("datos")
						.doc("pedidos")
						.set({ listado: pedidosAux }),
					db
						.collection("facturas")
						.doc(id_factura)
						.set({
							...factura,
							generadaFecha: firebase.firestore.Timestamp.now(),
							historial: [
								{
									generadaFecha:
										firebase.firestore.Timestamp.now(),
									generadaUsuario: rootState.auth.user.email
										? rootState.auth.user.email
										: rootState.auth.user.uid,
								},
							],
						}),
				]);
			})
			.then(() => {
				return dispatch("generarPdfFactura", id_factura);
			})
			.then(() => {
				//generar PDF Listado
				var pListado;
				if (pedidosAux.length && pedidosAux.length > 0) {
					var doc = new jsPDF("l");
					doc.text(
						"#" +
							id_factura +
							" - LISTADO PEDIDOS " +
							idToTexto(id).toUpperCase(),
						10,
						10
					);
					doc.text(
						"DEL " + factura.rango[0] + " AL " + factura.rango[1],
						10,
						20
					);
					if (pedidosAux.length && pedidosAux.length > 0) {
						let contenido = pedidosAux.map((p) => {
							let c = Object.values(p);
							return c.map((cell) => {
								return {
									content: cell,
									styles: {
										fillColor: !!p.eliminado
											? [255, 88, 70]
											: null,
									},
								};
							});
						});
						console.log(contenido);
						console.log([...contenido]);
						doc.autoTable({
							head: [state.cabeceraTexto],
							body: [...contenido],
							startY: 40,
							/*willDrawCell: (data) => {
                console.log(data);
                var rows = data.table.body;
                if (data.row.index === rows.length - 1) {
                  doc.setFillColor(239, 154, 154);
                }
              },*/
						});
					}
					var pdfListadoPedidos = doc.output("blob");
					id =
						factura.modo == "directorio"
							? id.replace("directorio_", "")
							: id;
					var refListado = storage.ref(
						"facturas/" +
							id +
							"/" +
							id_factura +
							"/" +
							id_factura +
							"_listado_pedidos.pdf"
					);
					pListado = refListado
						.put(pdfListadoPedidos)
						.then((r) => r.ref.getDownloadURL());
				} else {
					pListado = Promise.resolve(null);
				}
				//pdf resumen factura
				var pResumen;
				if (pedidosAux.length && pedidosAux.length > 0) {
					var doc = new jsPDF();
					doc.text(
						"#" +
							id_factura +
							" - RESUMEN DATOS FACTURA " +
							idToTexto(id).toUpperCase(),
						10,
						10
					);
					doc.text(
						"DEL " + factura.rango[0] + " AL " + factura.rango[1],
						10,
						20
					);
					if (factura.resumen) {
						let cabecera = ["Concepto", "Cantidad"];
						let contenido = [
							["RESÚMENES FACTURA Y COSTES", "-"],
							[
								"Total Factura",
								factura.resumen.totalCantidadFacturar,
							],
							[
								"Total tasas por pedidos online",
								factura.resumen.totalTasas,
							],
							[
								"Cantidad que Mewosystems debe percibir",
								factura.resumen.sumaCobrar,
							],
							[
								"Total facturado por la plataforma online",
								factura.resumen.totalFacturado,
							],
							/*["Total cantidad disponible en la plataforma pago Online de Stripe",
                  factura.resumen.totalEnStripe],*/
							[
								"Transferencia que Mewosystems le va a realizar de su saldo Stripe",
								factura.resumen.totalTransferir,
							],
							[
								"Transferencia que Mewosystems va a recibir en concepto de pago de la factura de su saldo Stripe",
								factura.resumen.transferirMewo,
							],
							[
								"Cantidad adicional que queda pendiente pagar",
								factura.resumen.totalPagar,
							],
							["RESÚMENES DE TOTALES", "-"],
							[
								"Total a domicilio",
								factura.resumen.totalDomicilio,
							],
							["Total a recoger", factura.resumen.totalRecoger],
							[
								"Total pagado con tarjeta online",
								factura.resumen.totalTarjetaOnline,
							],
							[
								"Total pagado en efectivo",
								factura.resumen.totalEfectivo,
							],
							[
								"Total pagado tarjeta a domicilio",
								factura.resumen.totalTarjetaDomicilio,
							],
							[
								"Total pagado en local",
								factura.resumen.totalPagoEnLocal,
							],
						];
						doc.autoTable({
							head: [cabecera],
							body: [...contenido],
							startY: 40,
						});
					}
					var pdfResumen = doc.output("blob");
					var refResumen = storage.ref(
						"facturas/" +
							id +
							"/" +
							id_factura +
							"/" +
							id_factura +
							"_resumen_datos.pdf"
					);
					pResumen = refResumen
						.put(pdfResumen)
						.then((r) => r.ref.getDownloadURL());
				} else {
					pResumen = Promise.resolve(null);
				}

				var refFactura = storage.ref(
					"facturas/" +
						id +
						"/" +
						id_factura +
						"/" +
						id_factura +
						"_factura.pdf"
				);
				//var ref = storageRef.child('imagenes/productos/' + id + '.jpg');
				return Promise.all([
					pListado,
					pResumen,
					refFactura.getDownloadURL(),
				]);
			})
			.then((r) => {
				return db
					.collection("facturas")
					.doc(id_factura)
					.set(
						{
							estado: "generada",
							ficheros: {
								pedidos: r[0],
								resumenFactura: r[1],
								factura: r[2],
							},
						},
						{ merge: true }
					);
			})
			.then(() => {
				//return Promise.reject("ya si eso")
				return id_factura;
			})
			.catch((e) => {
				console.log(e);
				return Promise.reject(e);
			});
	},
	getFactura({}, id_factura) {
		return db
			.collection("facturas")
			.doc(id_factura)
			.get()
			.then((r) => {
				if (r.exists) {
					const d = {
						id: r.id,
						...r.data(),
					};
					return d;
				} else {
					return Promise.reject("factura/not-found");
				}
			});
	},
	eliminarFactura({}, id) {
		return db.collection("facturas").doc(id).delete();
	},
	getFacturas({ commit, state }) {
		var q = db.collection("facturas");
		if (state.estadoFiltrando != "todas") {
			q = q.where("estado", "==", state.estadoFiltrando);
		}
		return q
			.orderBy("generadaFecha", "desc")
			.get()
			.then((r) => {
				var res = [];
				if (r.size > 0) {
					res = r.docs.map((f) => {
						return {
							...f.data(),
							id: f.id,
						};
					});
				}
				commit("setFacturasArray", res);
			});
	},
	getFacturasNegocio({ rootState, commit }) {
		return db
			.collection("facturas")
			.where("negocio", "==", rootState.app.negocioGest)
			.orderBy("generadaFecha", "desc")
			.get()
			.then((r) => {
				var res = [];
				if (r.size > 0) {
					res = r.docs.map((f) => {
						return {
							...f.data(),
							id: f.id,
						};
					});
				}
				commit("setFacturasArray", res);
			});
	},
	getFacturasRestaurante({ rootState, commit }) {
		return db
			.collection("facturas")
			.where("restauranteSimple", "==", rootState.app.restauranteGest[0])
			.limit(10)
			.orderBy("generadaFecha", "desc")
			.get()
			.then((r) => {
				var res = [];
				if (r.size > 0) {
					return r.docs.map((f) => {
						return {
							...f.data(),
							id: f.id,
						};
					});
				}
			})
			.then((r) => {
				commit("setFacturasArray", r);
			})
			.catch((e) => console.log(e));
	},
	getFacturasAsociadosPartner({ rootState, commit }) {
		return Promise.all(
			rootState.app.partnerNegocios.map((n) => {
				return db
					.collection("facturas")
					.where("negocio", "==", n.id)
					.limit(10)
					.orderBy("generadaFecha", "desc")
					.get()
					.then((r) => {
						var res = [];
						if (r.size > 0) {
							return r.docs.map((f) => {
								return {
									...f.data(),
									id: f.id,
								};
							});
						}
					});
			})
		).then((r) => {
			commit(
				"setFacturasArray",
				r.flat().filter((f) => !!f)
			);
		});
	},
	getFacturasDirectorio({ rootState, commit }) {
		return db
			.collection("facturas")
			.where("negocio", "==", rootState.app.directorioGest)
			.limit(10)
			.orderBy("generadaFecha", "desc")
			.get()
			.then((r) => {
				var res = [];
				if (r.size > 0) {
					return r.docs.map((f) => {
						return {
							...f.data(),
							id: f.id,
						};
					});
				} else {
					return [];
				}
			})
			.then((r) => {
				commit(
					"setFacturasArray",
					r.filter((f) => !!f)
				);
			});
	},
	guardarConceptoFacturar({}, { conceptos, restaurante, negocio }) {
		if (restaurante) {
			return db
				.collection("restaurantes")
				.doc(restaurante)
				.collection("secreto")
				.doc("facturacion")
				.set(
					{
						conceptosFacturarGuardados: conceptos,
					},
					{ merge: true }
				);
		} else {
			return db
				.collection("negocios")
				.doc(negocio)
				.collection("secreto")
				.doc("facturacion")
				.set(
					{
						conceptosFacturarGuardados: conceptos,
					},
					{ merge: true }
				);
		}
	},
	getSaldoCuentaConectada({}, { tipo, id }) {
		var getSaldoCuentaConectada = functions.httpsCallable(
			"httpStripeGetSaldoCuentaConectada"
		);
		return getSaldoCuentaConectada({ tipo: tipo, id: id });
	},
	generarPdfFactura({}, id) {
		var generarFactura = functions.httpsCallable("httpFacturasGenerarPdf");
		return generarFactura(id);
	},
	enviarFacturaEmail({}, payload) {
		var enviar = functions.httpsCallable("httpFacturasEnviarEmail");
		let dataR;
		return enviar(payload)
			.then((data) => {
				dataR = data;
				if (payload.flag) {
					/*return db.collection('facturas').doc(payload.id).set({
            estado: 'enviada cliente'
          }, { merge: true })*/
				}
			})
			.then(() => {
				return dataR;
			});
	},

	payToNegRest({}, id) {
		var transferir = functions.httpsCallable("httpStripeTransferToConnect");
		return transferir(id);
	},
	payToMewo({}, payload) {
		var cobrar = functions.httpsCallable("httpStripeCobrarNegocio");
		return cobrar(payload);
	},
	cancelTransfer({}, id) {
		var transferirCancel = functions.httpsCallable(
			"httpStripeTransferToConnectCancel"
		);
		return transferirCancel(id);
	},
	getEmailsDefecto() {
		return db
			.collection("configuracion")
			.doc("emailsDefecto")
			.get()
			.then((res) => {
				if (res.exists) {
					return res.data().enviarFacturas
						? res.data().enviarFacturas
						: [];
				} else {
					return [];
				}
			});
	},
	saveDatoStripeTransferir({ rootState }, payload) {
		return db
			.collection("facturas")
			.doc(payload.id)
			.update({
				"resumen.totalTransferir": parseFloat(payload.nuevo),
				historial: firebase.firestore.FieldValue.arrayUnion({
					cambioCantidadTransferir:
						firebase.firestore.Timestamp.now(),
					cambioCantidadTransferirUsuario: rootState.auth.user
						? rootState.auth.user.email
						: "Sin Datos",
					cambioCantidadTransferirAdicional: {
						anterior: payload.antes,
						nuevo: parseFloat(payload.nuevo),
					},
				}),
			})
			.then(() => {
				//volvemos a generar el pdf resumen
				return db.collection("facturas").doc(payload.id).get();
			})
			.then((f) => {
				if (f.exists) {
					return f.data();
				} else {
					return Promise.reject("facturas/not-exists");
				}
			})
			.then((factura) => {
				var id =
					factura.restaurante && factura.restaurante.length > 0
						? factura.restaurante[0]
						: factura.negocio;
				var doc = new jsPDF();
				doc.text(
					"#" +
						payload.id +
						" - RESUMEN DATOS FACTURA " +
						idToTexto(id).toUpperCase(),
					10,
					10
				);
				doc.text(
					"DEL " + factura.rango[0] + " AL " + factura.rango[1],
					10,
					20
				);
				if (factura.resumen) {
					let cabecera = ["Concepto", "Cantidad"];
					let contenido = [
						["RESÚMENES FACTURA Y COSTES", "-"],
						[
							"Total Factura",
							factura.resumen.totalCantidadFacturar,
						],
						[
							"Total tasas por pedidos online",
							factura.resumen.totalTasas,
						],
						[
							"Cantidad que Mewosystems debe percibir",
							factura.resumen.sumaCobrar,
						],
						[
							"Total facturado por la plataforma online",
							factura.resumen.totalFacturado,
						],
						/*["Total cantidad disponible en la plataforma pago Online de Stripe",
                factura.resumen.totalEnStripe],*/
						[
							"Transferencia que Mewosystems le va a realizar de su saldo Stripe",
							factura.resumen.totalTransferir,
						],
						[
							"Transferencia que Mewosystems va a recibir en concepto de pago de la factura de su saldo Stripe",
							factura.resumen.transferirMewo,
						],
						[
							"Cantidad adicional que queda pendiente pagar",
							factura.resumen.totalPagar,
						],
						["RESÚMENES DE TOTALES", "-"],
						["Total a domicilio", factura.resumen.totalDomicilio],
						["Total a recoger", factura.resumen.totalRecoger],
						[
							"Total pagado con tarjeta online",
							factura.resumen.totalTarjetaOnline,
						],
						[
							"Total pagado en efectivo",
							factura.resumen.totalEfectivo,
						],
						[
							"Total pagado tarjeta a domicilio",
							factura.resumen.totalTarjetaDomicilio,
						],
						[
							"Total pagado en local",
							factura.resumen.totalPagoEnLocal,
						],
					];
					doc.autoTable({
						head: [cabecera],
						body: [...contenido],
						startY: 40,
					});
				}
				var pdfResumen = doc.output("blob");
				var refResumen = storage.ref(
					"facturas/" +
						id +
						"/" +
						payload.id +
						"/" +
						payload.id +
						"_resumen_datos.pdf"
				);
				return refResumen
					.put(pdfResumen)
					.then((r) => r.ref.getDownloadURL());
			})
			.then((url) => {
				return db.collection("facturas").doc(payload.id).update({
					"ficheros.resumenFactura": url,
				});
			});
	},
	saveDatosCobrar({ rootState }, payload) {
		return db
			.collection("facturas")
			.doc(payload.id)
			.update({
				"resumen.transferirMewo": parseFloat(payload.nuevo),
				historial: firebase.firestore.FieldValue.arrayUnion({
					cambioCantidadCobrar: firebase.firestore.Timestamp.now(),
					cambioCantidadCobrarUsuario: rootState.auth.user
						? rootState.auth.user.email
						: "Sin Datos",
					cambioCantidadCobrarAdicional: {
						anterior: payload.antes,
						nuevo: parseFloat(payload.nuevo),
					},
				}),
			})
			.then(() => {
				//volvemos a generar el pdf resumen
				return db.collection("facturas").doc(payload.id).get();
			})
			.then((f) => {
				if (f.exists) {
					return f.data();
				} else {
					return Promise.reject("facturas/not-exists");
				}
			})
			.then((factura) => {
				var id =
					factura.restaurante && factura.restaurante.length > 0
						? factura.restaurante[0]
						: factura.negocio;
				var doc = new jsPDF();
				doc.text(
					"#" +
						payload.id +
						" - RESUMEN DATOS FACTURA " +
						idToTexto(id).toUpperCase(),
					10,
					10
				);
				doc.text(
					"DEL " + factura.rango[0] + " AL " + factura.rango[1],
					10,
					20
				);
				if (factura.resumen) {
					let cabecera = ["Concepto", "Cantidad"];
					let contenido = [
						["RESÚMENES FACTURA Y COSTES", "-"],
						[
							"Total Factura",
							factura.resumen.totalCantidadFacturar,
						],
						[
							"Total tasas por pedidos online",
							factura.resumen.totalTasas,
						],
						[
							"Cantidad que Mewosystems debe percibir",
							factura.resumen.sumaCobrar,
						],
						[
							"Total facturado por la plataforma online",
							factura.resumen.totalFacturado,
						],
						/*["Total cantidad disponible en la plataforma pago Online de Stripe",
                factura.resumen.totalEnStripe],*/
						[
							"Transferencia que Mewosystems le va a realizar de su saldo Stripe",
							factura.resumen.totalTransferir,
						],
						[
							"Transferencia que Mewosystems va a recibir en concepto de pago de la factura de su saldo Stripe",
							factura.resumen.transferirMewo,
						],
						[
							"Cantidad adicional que queda pendiente pagar",
							factura.resumen.totalPagar,
						],
						["RESÚMENES DE TOTALES", "-"],
						["Total a domicilio", factura.resumen.totalDomicilio],
						["Total a recoger", factura.resumen.totalRecoger],
						[
							"Total pagado con tarjeta online",
							factura.resumen.totalTarjetaOnline,
						],
						[
							"Total pagado en efectivo",
							factura.resumen.totalEfectivo,
						],
						[
							"Total pagado tarjeta a domicilio",
							factura.resumen.totalTarjetaDomicilio,
						],
						[
							"Total pagado en local",
							factura.resumen.totalPagoEnLocal,
						],
					];
					doc.autoTable({
						head: [cabecera],
						body: [...contenido],
						startY: 40,
					});
				}
				var pdfResumen = doc.output("blob");
				var refResumen = storage.ref(
					"facturas/" +
						id +
						"/" +
						payload.id +
						"/" +
						payload.id +
						"_resumen_datos.pdf"
				);
				return refResumen
					.put(pdfResumen)
					.then((r) => r.ref.getDownloadURL());
			})
			.then((url) => {
				return db.collection("facturas").doc(payload.id).update({
					"ficheros.resumenFactura": url,
				});
			});
	},
	archivarFactura({ rootState }, payload) {
		return db
			.collection("facturas")
			.doc(payload.id)
			.set(
				{
					estado: "archivada",
					historial: firebase.firestore.FieldValue.arrayUnion({
						archivada: firebase.firestore.Timestamp.now(),
						archivadaUsuario: rootState.auth.user
							? rootState.auth.user.email
							: "Sin Datos",
					}),
				},
				{ merge: true }
			);
	},
	marcarPagado({ rootState }, payload) {
		return db
			.collection("facturas")
			.doc(payload.id)
			.update({
				historial: firebase.firestore.FieldValue.arrayUnion({
					transferidoMewo: firebase.firestore.Timestamp.now(),
					transferidoMewoUsuario: rootState.auth.user
						? rootState.auth.user.email
						: "Sin Datos",
					transferidoMewoModo: "MARCADO PAGADO - " + payload.motivo,
				}),
			});
	},
	guardarFormaPago({}, id) {
		var guardarFormaPago = functions.httpsCallable(
			"httpStripeFacturacionAddFormaPago"
		);
		return guardarFormaPago(id).then((r) => r.data);
	},
	getFormasPago({}, id) {
		var get = functions.httpsCallable("httpStripeFacturacionGetFormasPago");
		return get(id).then((r) => r.data.data);
	},
	datosPartnerComision({ rootState }, factura) {
		return db
			.collection("partners")
			.doc(factura.comision)
			.get()
			.then((r) => {
				if (r.exists) {
					let datos = r.data();
					let f = datos.negociosComisiones.find(
						(c) => c.negocio == factura.negocio
					);
					return f ? { comisionPorcentaje: f.comision } : false;
				} else {
					return false;
				}
			});
	},
	generarComision({ rootState }, factura) {
		var foundNc;
		var comisionDefinitivaPartner;
		var subtotalCantidadTransferirPartner;
		return Promise.all([
			db.collection("partners").doc(factura.comision).get(),
			db.collection("facturas").doc(factura.id).get(),
			db
				.collection("facturas")
				.doc(factura.id)
				.collection("datos")
				.doc("pedidos")
				.get(),
		])

			.then((r) => {
				if (!r[0].exists)
					return Promise.reject("fallo en los datos de partner");
				if (!r[1].exists)
					return Promise.reject("fallo en los datos de factura");
				if (!r[2].exists)
					return Promise.reject(
						"fallo en los datos de pedidos de factura"
					);
				const partner = r[0].data();
				const fact = r[1].data();
				const pedidos = r[2].data().listado;
				var cliente =
					fact.modo == "negocio" ? fact.negocio : fact.restaurante[0];
				foundNc = partner.negociosComisiones.find(
					(nC) => nC.negocio == cliente
				);
				if (!foundNc && fact.modo == "restauranteIndividual") {
					//buscamos por negocio
					cliente = fact.negocio;
					foundNc = partner.negociosComisiones.find(
						(nC) => nC.negocio == cliente
					);
				}
				if (foundNc) {
					const pedidosGastoOnline = pedidos.map((p) => {
						p.comisionGastoGestionPago = 0;
						if (p.forma_pago == "Tarjeta online") {
							p.comisionGastoGestionPago =
								0.25 + (1.4 / 100) * parseFloat(p.precioTotal);
						}
						return p;
					});
					//miramos si se ha pasado un valor para la comisión, si no se pone el de defecto
					comisionDefinitivaPartner = factura.comisionPorcentaje
						? parseFloat(factura.comisionPorcentaje)
						: parseFloat(foundNc.comision);
					const comisionGastoGestionPagoTotal = redondeo(
						pedidosGastoOnline.reduce(
							(a, b) => a + (b.comisionGastoGestionPago || 0),
							0
						)
					);
					subtotalCantidadTransferirPartner = redondeo(
						(fact.resumen.subtotalCantidadFacturar -
							comisionGastoGestionPagoTotal) *
							comisionDefinitivaPartner
					);

					//pdf resumen factura
					var pResumen;
					if (pedidos.length && pedidos.length > 0) {
						var doc = new jsPDF();
						doc.text(
							"#" +
								factura.id +
								" - RESUMEN DATOS COMISIÓN " +
								idToTexto(foundNc.negocio).toUpperCase(),
							10,
							10
						);
						if (fact.resumen) {
							let cabecera = ["Concepto", "Cantidad"];
							let contenido = [
								[
									"TOTAL FACTURA CON IVA",
									fact.resumen.totalCantidadFacturar,
								],
								[
									"SUBTOTAL",
									fact.resumen.subtotalCantidadFacturar,
								],
								[
									"GASTOS PAGOS ONLINE",
									comisionGastoGestionPagoTotal,
								],
								[
									"CANTIDAD LIBRE DE GASTOS",
									redondeo(
										fact.resumen.subtotalCantidadFacturar -
											comisionGastoGestionPagoTotal
									),
								],
								[
									"PORCENTAJE PARA PATNER",
									(
										comisionDefinitivaPartner * 100
									).toString() + " %",
								],
								[
									"SUBTOTAL DE CANTIDAD QUE MEWOSYSTEMS PAGARÁ AL PARTNER",
									subtotalCantidadTransferirPartner,
								],
								[
									"CANTIDAD CON IVA QUE MEWOSYSTEMS PAGARÁ AL PARTNER",
									redondeo(
										subtotalCantidadTransferirPartner * 1.21
									),
								],
							];

							doc.autoTable({
								head: [cabecera],
								body: [...contenido],
								startY: 30,
							});
						}
						var pComision;
						var pdfComision = doc.output("blob");
						var refComision = storage.ref(
							"facturas/" +
								cliente +
								"/" +
								factura.id +
								"/" +
								factura.id +
								"_comisiones_" +
								foundNc.negocio +
								".pdf"
						);
						pComision = refComision
							.put(pdfComision)
							.then((r) => r.ref.getDownloadURL());
					} else {
						pComision = Promise.resolve(null);
					}
					return pComision;
				}
			})
			.then((r) => {
				if (foundNc) {
					return Promise.all([
						// db.collection('comisiones').doc(factura.id + '_' + r[0].id).set({
						//   estado: 'generada',
						//   comisionGastoGestionPagoTotal: comisionGastoGestionPagoTotal,
						//   subtotalCantidadFacturar: fact.resumen.subtotalCantidadFacturar,
						//   subtotalCantidadTransferirPartner: subtotalCantidadTransferirPartner,
						//   historial: [{
						//     generadaFecha: firebase.firestore.Timestamp.now(),
						//     generadaUsuario: (rootState.auth.user.email) ? rootState.auth.user.email : rootState.auth.user.uid,
						//   }]
						// }, { merge: true }),
						// db.collection('comisiones').doc(factura.id + '_' + r[0].id).collection('datos').doc('pedidos').set({
						//   listado: pedidosGastoOnline
						// }),
						db
							.collection("facturas")
							.doc(factura.id)
							.update({
								historial:
									firebase.firestore.FieldValue.arrayUnion({
										comisionGenerada:
											firebase.firestore.Timestamp.now(),
										comisionGeneradaUsuario: rootState.auth
											.user
											? rootState.auth.user.email
											: "Sin Datos",
									}),
								"ficheros.resumenComision": r,
								comisionDefinitivaPartner:
									comisionDefinitivaPartner,
								comisionSubtotalCantidadTransferirPartner:
									subtotalCantidadTransferirPartner,
								comisionTotalCantidadTransferirPartner:
									redondeo(
										subtotalCantidadTransferirPartner * 1.21
									),
							}),
						// return db.collection('facturas').doc(payload.id).update({
						//   "ficheros.resumenFactura": url
						// })
					]);
				} else {
					return Promise.reject("no se encuentra el partner");
				}
			});
	},
	descargarListadoFacturas({}, { fechas, negocios }) {
		let inicio = moment(fechas[0]).toDate();
		let fin = moment(fechas[1]).toDate();
		var facturas = [];
		return db
			.collection("facturas")
			.where("generadaFecha", ">", inicio)
			.where("generadaFecha", "<", fin)
			.orderBy("generadaFecha", "desc")
			.get()
			.then((r) => {
				facturas = r.docs
					.map((f) => {
						return {
							...f.data(),
							id: f.id,
						};
					})
					.filter((f) => {
						return (
							negocios.length == 0 || negocios.includes(f.negocio)
						);
					});

				var cabecera = [
					"Nº Factura",
					"Fecha Generada",
					"Enlace factura",
					"Base imponible",
					"IVA",
					"Total factura",
					"Negocio",
					"Restaurante",
					"Rango Facturación",
					"Porcentaje partner",
					"Subtotal Partner",
					"Total con impuestos Partner",
				];
				const workbook = XLSX.utils.book_new();
				var ws = XLSX.utils.aoa_to_sheet([
					cabecera,
					...facturas.map((f) => {
						return [
							f.id,
							moment(f.generadaFecha.toDate()).format(
								"DD-MM-YYYY HH:mm"
							),
							f.ficheros.factura,
							f.resumen.subtotalCantidadFacturar,
							f.resumen.impuestoCantidadFacturar,
							f.resumen.totalCantidadFacturar,
							f.negocio,
							Array.isArray(f.restaurante)
								? f.restaurante.join(", ")
								: "-",
							f.rango.toString(" - "),
							f.comisionDefinitivaPartner
								? (
										f.comisionDefinitivaPartner * 100
								  ).toString() + " %"
								: "-",
							f.comisionSubtotalCantidadTransferirPartner
								? f.comisionSubtotalCantidadTransferirPartner
								: "-",
							f.comisionTotalCantidadTransferirPartner
								? f.comisionTotalCantidadTransferirPartner
								: "-",
						];
					}),
				]);
				var wscols = [
					{ wch: 20 },
					{ wch: 20 },
					{ wch: 20 },
					{ wch: 20 },
					{ wch: 20 },
					{ wch: 20 },
					{ wch: 20 },
					{ wch: 20 },
					{ wch: 20 },
					{ wch: 20 },
					{ wch: 20 },
					{ wch: 20 },
				];
				ws["!cols"] = wscols;
				facturas.forEach((f) => {});
				XLSX.utils.book_append_sheet(workbook, ws, fechas.slice(0, 25));
				const filename =
					"listado facturas Funeats " + fechas.join(" / ");
				XLSX.writeFile(workbook, `${filename}.xlsx`);
			});
	},
	generarExcelListadoPedidos({ state }, { rango, pedidos, id_factura }) {
		let nombreCabecera1 = "#" + id_factura + " - LISTADO PEDIDOS ";
		let nombreCabecera2 = "DEL " + rango[0] + " AL " + rango[1];

		var facturas = [];

		var cabecera = state.cabeceraTexto;
		const workbook = XLSX.utils.book_new();
		console.log([
			[nombreCabecera1],
			[nombreCabecera2],
			cabecera,
			...pedidos.map((p) => {
				//['#', 'Fecha', 'Modo', 'Pago', 'Cantidad', '% Online', 'Fijo Online', '% Pedido', 'Fijo Pedido', 'Total Tasa']
				return [
					p.id,
					p.fecha,
					p.modo,
					p.forma_pago,
					p.precioTotal,
					p.tasaPagoTarjetaPorcentaje,
					p.tasaPagoTarjetaFijo,
					p.tasaPedidoPorcentaje,
					p.tasaPedidoFijo,
					p.tasaTotal,
				];
			}),
		]);
		var ws = XLSX.utils.aoa_to_sheet([
			[nombreCabecera1],
			[nombreCabecera2],
			cabecera,
			...pedidos.map((p) => {
				//['#', 'Fecha', 'Modo', 'Pago', 'Cantidad', '% Online', 'Fijo Online', '% Pedido', 'Fijo Pedido', 'Total Tasa']
				return [
					p.id,
					p.fecha,
					p.modo,
					p.forma_pago,
					p.precioTotal,
					p.tasaPagoTarjetaPorcentaje,
					p.tasaPagoTarjetaFijo,
					p.tasaPedidoPorcentaje,
					p.tasaPedidoFijo,
					p.tasaTotal,
				];
			}),
		]);
		var wscols = [
			{ wch: 20 },
			{ wch: 20 },
			{ wch: 20 },
			{ wch: 20 },
			{ wch: 20 },
			{ wch: 20 },
			{ wch: 20 },
			{ wch: 20 },
			{ wch: 20 },
			{ wch: 20 },
			{ wch: 20 },
			{ wch: 20 },
		];
		ws["!cols"] = wscols;

		XLSX.utils.book_append_sheet(workbook, ws, id_factura.slice(0, 25));
		const filename =
			"listado pedidos Funeats " + id_factura + " " + rango.join(" / ");
		XLSX.writeFile(workbook, `${filename}.xlsx`);
	},

	volcarHolded({}, item) {
		var f = functions.httpsCallable("httpFacturasVolcarHolded");
		var pay = functions.httpsCallable("httpFacturasVolcarHoldedPay");
		var attachFile = functions.httpsCallable(
			"httpFacturasVolcarHoldedAttach"
		);
		return f(item)
			.then(() => {
				return attachFile(item);
			})
			.then(() => {
				if (!!item.cobrado) {
					return pay(item);
				} else {
					return Promise.resolve();
				}
			});
	},
};
